<div class="footer" fxLayout="row">
        <div fxFlex="5">
            <img src="assets/img/flag.jpg" class="flag">
        </div>
        <div fxFlex="85" style="cursor: default; padding-top: 7px;">
            This project has received funding from the European Union’s Horizon 2020 research and innovation programme
            under
            grant agreement No 861915.&emsp;© 2020
        </div>
        <div class="social" fxFlex="10">
            <a href="mailto: info@ditect.eu" style="color: #c8d3e4;">
                <i class="fas fa-envelope fa-lg"></i>
            </a>
            <a href="https://www.facebook.com/DitectProject" style="color: #c8d3e4;">
                <i class="fab fa-facebook fa-lg"></i>
            </a>
            <a href="https://twitter.com/DitectProject" style="color: #c8d3e4;">
                <i class="fab fa-twitter fa-lg"></i>
            </a>
            <a href="https://www.linkedin.com/company/ditect-project-eu-china/" style="color: #c8d3e4;">
                <i class="fab fa-linkedin-in fa-lg"></i>
            </a>
            <a href="https://www.youtube.com/channel/UCqe6D5LQ1Np5mQ_-2p0RRDw" style="color: #c8d3e4;">
                <i class="fab fa-youtube fa-lg"></i>
            </a>
        </div>

</div>